import { useAppDispatch, useAppSelector } from "app/hooks/hooks";
import { useEffect } from "react";
import { getCategoryType3Tags, getCategoryType3TagsSelector, getTags, getTagsSelector } from "redux/userList/userSlice";

const useGetFormOptions = () => {
	const dispatch = useAppDispatch();
	const { tags, loading: isGettingTags } = useAppSelector(getTagsSelector);
	const { tags: categoryType3Tags, loading: isGettingCategory3Tags } = useAppSelector(getCategoryType3TagsSelector);

	useEffect(() => {
		try {
			dispatch(getCategoryType3Tags());
			dispatch(getTags());
		} catch (e) {
			// eslint-disable-next-line no-console
			console.error(e);
		}
	}, []);

	return {
		isLoading: isGettingCategory3Tags === 1 || isGettingTags === 1,
		tags,
		categoryType3Tags
	};
};

export default useGetFormOptions;
